<template>
<div>
    <v-spacebaseevmos v-if="chainId == 9001"></v-spacebaseevmos>
    <v-spacebaseevmostest v-if="chainId == 9000"></v-spacebaseevmostest>
    <v-spacebasezksync v-if="chainId == 280"></v-spacebasezksync>
    <v-spacebasezksyncmain v-if="chainId == 324"></v-spacebasezksyncmain>
    <v-spacebasescroll v-if="chainId == 534353"></v-spacebasescroll>
    <v-spacebasescrollsepolia v-if="chainId == 534351"></v-spacebasescrollsepolia>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            if (location.href.split('?')[1]) {
                var code =location.href.split('?')[1].split('&')[1].split('=')[1];
                if(code[code.length-1] == 0){
                    this.chainId = 9000
                } else if (code[code.length-1] == 1){
                    this.chainId = 280
                } else if (code[code.length-1] == 2){
                    this.chainId = 9001
                } else if (code[code.length-1] == 3){
                    this.chainId = 324
                } else if (code[code.length-1] == 4){
                    this.chainId = 534353
                }
            } else {
                this.chainId = localStorage.getItem('chainId') || 9001
            }
        },
    }
</script> 